import React from 'react';
import PropTypes from 'prop-types';

/**
 *
 * @param value
 * @param children
 * @returns {React.Component}
 * @constructor
 */
const NANcheck = ({value, children}) => {
  if (value === null || typeof value !== 'number' || isNaN(value) || !Number.isFinite(value)) {
    return <span> - </span>;
  }

  return children;
};

NANcheck.propTypes = {
  /**
   * The value to check if it's a number
   */
  value: PropTypes.number,

  /**
   * The component to render if value is a number
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
};

export default NANcheck;
